module.exports = __webpack_public_path__ + "static/media/naira (2).590bfc41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/naira (2).png
// module id = 281
// module chunks = 0